
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Symbol} from '../core/Symbol';
import {FieldModelSymbol} from '../core/Symbol';

/**
 * SymbolsUpdateNotify struct
 */
class SymbolsUpdateNotify {
  /**
   * Initialize struct
   * @param {!Array=} allSymbols
   * @constructor
   */
  constructor (allSymbols = []) {
    this.AllSymbols = allSymbols
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolsUpdateNotify}
   * @param {!SymbolsUpdateNotify} other Other struct
   * @returns {!SymbolsUpdateNotify} This struct
   */
  copy (other) {
    if (other.AllSymbols != null) {
      this.AllSymbols = []
      for (let item of other.AllSymbols) {
        if (item != null) {
          let tempItem
          tempItem = Symbol.fromObject(item)
          this.AllSymbols.push(tempItem)
        } else {
          this.AllSymbols.push(null)
        }
      }
    } else {
      this.AllSymbols = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolsUpdateNotify}
   * @returns {!SymbolsUpdateNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolsUpdateNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolsUpdateNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolsUpdateNotify}
   * @param {!SymbolsUpdateNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolsUpdateNotify)) {
      throw new TypeError('Instance of SymbolsUpdateNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolsUpdateNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      AllSymbols: ((this.AllSymbols != null) ? Array.from(this.AllSymbols, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolsUpdateNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolsUpdateNotify} other Object value
   * @returns {!SymbolsUpdateNotify} Created struct
   */
  static fromObject (other) {
    return new SymbolsUpdateNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolsUpdateNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolsUpdateNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolsUpdateNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 8014
  }
}

export { SymbolsUpdateNotify };

/**
 * Fast Binary Encoding SymbolsUpdateNotify field model
 */
class FieldModelSymbolsUpdateNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.AllSymbols = new fbe.FieldModelVector(new FieldModelSymbol(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.AllSymbols.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.AllSymbols.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolsUpdateNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 8014
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllSymbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllSymbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllSymbols.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!SymbolsUpdateNotify} fbeValue Default value, defaults is new SymbolsUpdateNotify()
   * @returns {!SymbolsUpdateNotify} SymbolsUpdateNotify value
   */
  get (fbeValue = new SymbolsUpdateNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!SymbolsUpdateNotify} fbeValue SymbolsUpdateNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllSymbols.fbeSize) <= fbeStructSize) {
      this.AllSymbols.get(fbeValue.AllSymbols)
    } else {
      fbeValue.AllSymbols.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllSymbols.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolsUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {!SymbolsUpdateNotify} fbeValue SymbolsUpdateNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolsUpdateNotify}
   * @param {SymbolsUpdateNotify} fbeValue SymbolsUpdateNotify value
   */
  setFields (fbeValue) {
    this.AllSymbols.set(fbeValue.AllSymbols)
  }
}

export { FieldModelSymbolsUpdateNotify };

/**
 * Fast Binary Encoding SymbolsUpdateNotify model
 */
class SymbolsUpdateNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolsUpdateNotify(this.buffer, 4)
  }

  /**
   * Get the SymbolsUpdateNotify model
   * @this {!SymbolsUpdateNotifyModel}
   * @returns {!FieldModelSymbolsUpdateNotify} model SymbolsUpdateNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolsUpdateNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolsUpdateNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolsUpdateNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolsUpdateNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolsUpdateNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolsUpdateNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolsUpdateNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolsUpdateNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolsUpdateNotifyModel}
   * @param {!SymbolsUpdateNotify} value SymbolsUpdateNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolsUpdateNotifyModel}
   * @param {!SymbolsUpdateNotify} value SymbolsUpdateNotify value, defaults is new SymbolsUpdateNotify()
   * @return {!object} Deserialized SymbolsUpdateNotify value and its size
   */
  deserialize (value = new SymbolsUpdateNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolsUpdateNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolsUpdateNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolsUpdateNotifyModel}
   * @param {!number} prev Previous SymbolsUpdateNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolsUpdateNotifyModel };
